import { defineMessages } from 'react-intl';

const messages: {
	pageIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portalDownIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	portals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	pageIcon: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final',
		defaultMessage: 'Page icon',
		description:
			'The accessible label for the page icon displayed next to portal navigation items in the portals drop-down in the navbar.',
	},
	portalDownIcon: {
		defaultMessage: 'Open portals dropdown',
		description:
			'The accessible label for the chevron-down icon on the button that opens the portals drop-down in the navbar navigation.',
		id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final',
	},
	portals: {
		id: 'company-hub.hub-app-shell.navbar.nav-links.portals.non-final',
		defaultMessage: 'Portals',
		description: 'Navigation link label for the portals dropdown',
	},
});

export default messages;
